export type Status =
  | 'Accepted'
  | 'Blocked'
  | 'Expired'
  | 'Invalid'
  | 'ConcurrentTx';

export type Reason = string;

export type Format = string;
export type Phase = string;
export type Location = string;
export type Unit = string;
export type Context = string;
export type Measurand = string;

interface SampledValueModelDto {
  value: string;
  context: Context;
  format: Format;
  measurand: Measurand;
  phase: Phase;
  location: Location;
  unit: Unit;
}

interface TransactionDataModelDto {
  timestamp: string;
  sampledValue: SampledValueModelDto[];
}

interface MeterValuesModelDto {
  timestamp: string;
  sampledValue: SampledValueModelDto[];
}

export interface BrokerTransactionDto {
  identityKey: string;
  transactionId: number;
  evseId: string;
  connectorId: number;
  reservationId: number | null;
  idTagStart: string;
  idTagInfoStart: {
    expiryDate: string;
    parentIdTag: string;
    status: Status;
  };
  idTagStop: string;
  reason: Reason;
  transactionData: TransactionDataModelDto[] | null;
  meterValues: MeterValuesModelDto[] | null;
  meterStart: number;
  meterStop: number;
  timestampStart: string;
  timestampStop: string;
  duration: string;
  consumption: string;
  tokenUid: string;
  transactionStatus: TransactionStatusEnum;
  transactionFinishReason: TransactionFinishReasonEnum;
}

export enum TransactionStatusEnum {
  successFinish = 'successFinish',
  errorFinish = 'errorFinish',
  charging = 'charging',
}

export enum TransactionFinishReasonEnum {
  deAuthorized = 'deAuthorized',
  emergencyStop = 'emergencyStop',
  eVDisconnected = 'eVDisconnected',
  hardReset = 'hardResetReason',
  local = 'local',
  other = 'other',
  powerLoss = 'powerLoss',
  reboot = 'reboot',
  remote = 'remote',
  softReset = 'softResetReason',
  unlockCommand = 'unlockCommand',
}
